import MicroModal from 'micromodal';

window.addEventListener('DOMContentLoaded', (ev) => {

	$ = jQuery.noConflict();

	for (const key in PixelsmithBlocks) {
		if (PixelsmithBlocks.hasOwnProperty(key)) {
			const block = PixelsmithBlocks[key];
			block.init();
		}
	}

	for (const key in PixelsmithModules) {
		if (PixelsmithModules.hasOwnProperty(key)) {
			const block = PixelsmithModules[key];
			block.init();
		}
	}

	if (undefined !== window.PXCustomBlocks && window.acf) {
		window.PXCustomBlocks.forEach((b) => {
			let camelCasedName =
				'PX' +
				b.name
					.split('-')
					.map((el) => el.charAt(0).toUpperCase() + el.slice(1))
					.join('');

			window.acf.addAction(`render_block_preview/type=${b.name}`, PixelsmithBlocks[camelCasedName].init);
		});
	}
});
